import fetch from '../utils/fetch'

export default {
    //业务
    getNormalBussinessTypeList(params) {
        return fetch({
            url: '/BusinessType/getNormalBussinessTypeList',
            method: 'get',
            params
        })
    },

    departmentTreeData(data) {
        return fetch({
            url: '/Department/departmentTreeData',
            method: 'post',
            data
        })
    },

    getCustomerList(data) {
        return fetch({
            url: '/Customer/getCustomerList',
            method: 'post',
            data
        })
    },

    getContractAllList(data) {
        return fetch({
            url: '/Contract/getContractAllList',
            method: 'post',
            data
        })
    },

    AddBusiness(data) {
        return fetch({
            url: '/Business/AddBusiness',
            method: 'post',
            data
        })
    },

    updateBusiness(data) {
        return fetch({
            url: '/Business/updateBusiness',
            method: 'post',
            data
        })
    },

    getBusinessList(data) {
        return fetch({
            url: '/Business/getBusinessList',
            method: 'post',
            data
        })
    },

    getBusinessById(params) {
        return fetch({
            url: '/Business/getBusinessById',
            method: 'get',
            params
        })
    },

    getBusinessLeader(params) {
        return fetch({
            url: '/Business/getBusinessLeader',
            method: 'get',
            params
        })
    },

    queryUser(data) {
        return fetch({
            url: '/User/queryUser',
            method: 'post',
            data
        })
    },

    addBusinessPeople(data) {
        return fetch({
            url: '/BusinessPeople/addBusinessPeople',
            method: 'post',
            data
        })
    },

    updateBusinessPeople(data) {
        return fetch({
            url: '/BusinessPeople/updateBusinessPeople',
            method: 'post',
            data
        })
    },

    finishPeopleDistribution(params) {
        return fetch({
            url: '/Business/finishPeopleDistribution',
            method: 'get',
            params
        })
    },

    startReport(params) {
        return fetch({
            url: '/Business/startReport',
            method: 'get',
            params
        })
    },

    addBusinessIssue(data) {
        return fetch({
            url: '/BusinessIssue/addBusinessIssue',
            method: 'post',
            data
        })
    },

    getWorkLogList(data) {
        return fetch({
            url: '/WorkLog/getWorkLogList',
            method: 'post',
            data
        })
    },

    getJoinPeopleInfoByBusinessId(params) {
        return fetch({
            url: '/Business/getJoinPeopleInfoByBusinessId',
            method: 'get',
            params
        })
    },
}
